export const identityFields = ['is_foreign', 'nationality', 'document_type', 'document_country', 'document_number'];
export function patientIdentity(patient = {}) {
  return Object.fromEntries(identityFields.map(key => [key, patient?.[key] ?? (key === 'is_foreign' ? false : null)]));
}
export function documentLabel(patient = {}) {
  return patient.document_number || patient.patient_cpf || patient.user_cpf || '';
}

export function identityError(error) {
  const data = error.response?.data;
  return Object.values(data?.errors || {}).flat()[0] || data?.message || (typeof data === 'string' ? data : 'Não foi possível salvar. Confira os dados e tente novamente.');
}

export function isPatientDeceased(patient) {
  if (!patient) {
    return false;
  }
  if (patient.patient_died_at) {
    return true;
  }
  return patient.patient_died === true || patient.patient_died === 1 || patient.patient_died === '1' || patient.patient_died === 't';
}
